import React, { useMemo } from "react";

import Loader from "../../../Loader/Loader";
import { useGetTelemetryData } from "../../useGetTelemetryData";
import { ReactComponent as ShuntSVG } from "./Shunt.svg";
import { getShuntSignalConfig } from "./shunt-signal-utils";
import CircuitViewSVGPopulator from "../CircuitViewSVGPopulator";

interface Props {
  open: boolean;
  gear_type: string;
  device_id: string;
  handleClose: () => void;
  sg_type?: "MAIN" | "SHUNT";
}
const ShuntSignalCircuitView: React.FC<Props> = (props) => {
  const { gear_type, device_id } = props;
  const required_device_id_list = useMemo(() => [device_id], [device_id]);
  const { data, loading: telemetry_state_loading } = useGetTelemetryData({
    deviceCategory: gear_type,
    required_device_id_list: required_device_id_list,
  });

  const data_map = getShuntSignalConfig(device_id);
  if (telemetry_state_loading) {
    return <Loader />;
  }
  return <CircuitViewSVGPopulator data={data} data_map={data_map} gear_type={gear_type} Component={ShuntSVG} />;
};

export default ShuntSignalCircuitView;
